<template>
  <EquipmentRow :key="`${vsd?.id}`" data-cy="vsd-row-equipment-row">
    <template #left></template>
    <template #default="{ toggle }">
      <AddRemoveButtons
        :hide-add-below="true"
        :disable-remove="!equipment.vsd_id"
        data-cy="vsd-row-add-remove-buttons"
        @remove="
          equipmentForm.update({
            r_vsd: null,
            vsd_id: null
          })
        "
      >
        <template #middle-content>
          <EquipmentPanel
            class="flex-grow-1"
            :rule-names="[
              'vsd_kva_rating',
              'vsd_amp_rating',
              'vsd_sine_wave',
              'vsd_obsolete'
            ]"
            data-cy="vsd-row-equipment-panel"
            @toggle="toggle"
          >
            <template #header>
              <span data-cy="vsd-row-panel-header">VSD</span>
            </template>
            <template v-if="vsd" #trigger>
              <span data-cy="vsd-row-panel-trigger">{{
                computeVsdLabel(vsd)
              }}</span>
            </template>
          </EquipmentPanel>
        </template>
      </AddRemoveButtons>
    </template>
    <template #expand="{ toggle }"
      ><VSDSearchView
        :is-admin="false"
        data-cy="vsd-row-search-view"
        @select="handleVSDSelect($event, toggle)"
      />
    </template>
    <template #right>
      <ConverterInput
        label="Input Line Voltage"
        :model-value="parameters.vsd_input_voltage"
        mode="write"
        :base-unit="VoltageUnits.Volts"
        :model="VoltageUnits.options()"
        data-cy="vsd-row-converter-input"
        @update:model-value="
          parametersForm.update({
            vsd_input_voltage: $event
          })
        "
      />
    </template>
  </EquipmentRow>
</template>
<script setup lang="ts">
import { computed, provide } from "vue";
import { computeVsdLabel } from "@/models/equipment/vsd/properties";
import EquipmentRow from "@/components/scenarios/EquipmentRow.vue";
import EquipmentPanel from "@/components/scenarios/EquipmentPanel.vue";
import { injectStrict } from "@/utils/utils";
import {
  equipmentFormKey,
  parametersFormKey
} from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import VSDSearchView from "@/components/equipment/vsd/VSDSearchView.vue";
import ConverterInput from "@/components/ConverterInput.vue";
import { VoltageUnits } from "@/libs/units/voltage";
import AddRemoveButtons from "@/components/AddRemoveButtons.vue";
import type { Variable_Speed_Drives } from "gql/api";

const equipmentForm = injectStrict(equipmentFormKey);
const equipment = computed(() => equipmentForm.data.value);

const parametersForm = injectStrict(parametersFormKey);
const parameters = computed(() => parametersForm.data.value);
const vsd = computed(() => equipment.value.r_vsd);

provide(
  "selected-equipment-id",
  computed(() => vsd.value?.id)
);

function handleVSDSelect(vsd: Variable_Speed_Drives, toggle: () => void) {
  toggle();
  equipmentForm.update({
    r_vsd: vsd,
    vsd_id: vsd?.id
  });
}
</script>
